import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

/**
 * @param {HTMLElement} section
 */
function initSectionSwiper(section) {
	const el = section.querySelector('.js-case-studies-swiper');
	const prevBtn = section.querySelector('.js-case-studies-prev');
	const nextBtn = section.querySelector('.js-case-studies-next');
	const pagination = section.querySelector('.js-case-studies-pagination');
	const slides = el?.querySelectorAll('.swiper-slide') ?? [];

	if (!el) {
		return null;
	}

	if (slides.length < 2) {
		section.querySelector('.case-studies__nav')?.setAttribute('hidden', 'hidden');
	}

	const ctaLink = section.querySelector('.js-case-studies-cta');
	const ctaLabel = section.querySelector('.js-case-studies-cta-label');

	/**
	 * Point the CTA button at the active slide's link and label. The button is
	 * hidden on slides that have no link set.
	 * @param {import('swiper').default} swiper
	 */
	function syncCta(swiper) {
		if (!ctaLink) {
			return;
		}
		const activeSlide = swiper.slides[swiper.activeIndex];
		const href = activeSlide?.dataset.ctaHref?.trim();
		const label = activeSlide?.dataset.ctaLabel?.trim();
		if (href) {
			ctaLink.setAttribute('href', href);
			ctaLink.removeAttribute('download');
			if (ctaLabel && label) {
				ctaLabel.textContent = label;
			}
			ctaLink.removeAttribute('hidden');
		} else {
			ctaLink.setAttribute('hidden', 'hidden');
		}
	}

	// iOS/WebKit chokes on transform-mode carousels (blank/frozen slides,
	// dead nav — see client-testimonials-swiper.js for the history). Native
	// scroll + scroll-snap on touch devices sidesteps that bug family.
	const isCoarsePointer = window.matchMedia?.('(pointer: coarse)').matches ?? false;

	return new Swiper(el, {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 30,
		watchOverflow: true,
		cssMode: isCoarsePointer,
		resistanceRatio: 0,
		// This panel is full-bleed to the screen edge on mobile; without this,
		// a drag starting near the edge can lose the gesture to iOS Safari's
		// own swipe-back navigation mid-scroll instead of panning the
		// carousel (#128).
		edgeSwipeDetection: 'prevent',
		watchSlidesProgress: false,
		navigation: {
			prevEl: prevBtn,
			nextEl: nextBtn,
		},
		pagination: {
			el: pagination,
			clickable: true,
		},
		on: {
			init: syncCta,
			slideChange: syncCta,
		},
	});
}

export function initCaseStudiesSwiper() {
	document.querySelectorAll('.js-case-studies-section').forEach((section) => {
		const el = section.querySelector('.js-case-studies-swiper');
		if (!el || el.swiper) {
			return;
		}

		initSectionSwiper(section);
	});
}
